import { createAsyncThunk } from "@reduxjs/toolkit"
import { push } from "redux-first-history"

import { handleApiError } from "../../../Utils/thunkHelpers"
import utils from "../../../Utils/utils"
import * as services from "../services"
import { topUpBalanceSuccess } from "./balance.actions"
import { BALANCE_SLICE_NAME } from "./balance.constants"

export const getBalance = createAsyncThunk(
  `${BALANCE_SLICE_NAME}/get_balance`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getBalance(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const updateBalance = createAsyncThunk(
  `${BALANCE_SLICE_NAME}/update_balance`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.updateBalance(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const setAutoTopUp = createAsyncThunk(
  `${BALANCE_SLICE_NAME}/set_auto_top_up`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.setAutoTopUp(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    // Echo the requested flag: the response body shape is not part of the contract.
    return { auto_top_up_enabled: params.enabled }
  }
)

export const topUpBalance = createAsyncThunk(
  `${BALANCE_SLICE_NAME}/top_up_balance`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.topUpBalance(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    // Success lands in the store before the redirect, the way the saga's
    // `put(success)` / `put(push(...))` pair did — /manual-top-up reads
    // `adyenSessionData` as soon as it mounts.
    dispatch(topUpBalanceSuccess(response.data))
    if (response.data?.redirect_url) {
      utils.goLink(response.data.redirect_url)
    } else {
      dispatch(push("/manual-top-up"))
    }
    return response.data
  }
)

export const firstTopUpBalance = createAsyncThunk(
  `${BALANCE_SLICE_NAME}/first_top_up_balance`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.firstTopUpBalance(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    // The saga config carried `redirect: "/manual-top-up"` for this request too, but its only
    // call site (the onboarding top-up step) always passed `notRedirect: true` and drives the
    // navigation itself from the resolved payload — so there is no redirect branch here.
    dispatch(topUpBalanceSuccess(response.data))
    return response.data
  }
)

export const getBalanceActivity = createAsyncThunk(
  `${BALANCE_SLICE_NAME}/get_balance_activity`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getBalanceActivity(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getBalanceActivityExport = createAsyncThunk(
  `${BALANCE_SLICE_NAME}/get_balance_activity_export`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getBalanceActivityExport(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getBalanceActivityFilterOptions = createAsyncThunk(
  `${BALANCE_SLICE_NAME}/get_balance_activity_filter_options`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getBalanceActivityFilterOptions(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)
